import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { OrderListRowAction } from 'commons/enums';
import {
  bulkPrioritizeOrderPick,
  bulkRetryUpdateFailedOrder,
  bulkUnPrioritizeOrderPick,
  prioritizeOrderPick,
  retryUpdateFailedOrder,
  setCancelNonPickedTask,
  unPrioritizeOrderPick,
} from 'redux-stores/actions';

import {
  IOpenBulkDialogData,
  IOpenDialogData,
} from '../type/open-dialog-state.interface';

export const OpenDialogConfig: Record<string, IOpenDialogData | null> = {
  prioritize: {
    title: 'Prioritize Task',
    content: (poNumber: string): string => {
      return `Are you sure to prioritize ${poNumber}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
      location?: number,
    ): void => {
      dispatch(prioritizeOrderPick({ poNumber, location }));
    },
  },
  unprioritize: {
    title: 'Unprioritize Task',
    content: (poNumber: string): string => {
      return `Are you sure to unprioritize ${poNumber}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
      location?: number,
    ): void => {
      dispatch(unPrioritizeOrderPick({ poNumber, location }));
    },
  },
  retry: {
    title: 'Submit Retry Update Failed Task',
    content: (poNumber: string): string => {
      return `Are you sure to submit retry ${poNumber}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
      location?: number,
    ): void => {
      dispatch(retryUpdateFailedOrder({ poNumber, location }));
    },
  },
  'no-pick-cancel': {
    title: 'No Picked Cancellation',
    content: (poNumber: string): string => {
      return `Are you sure to cancel ${poNumber}? This will skip pick pack process and will be visible in Cancelled Tab`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      poNumber: string,
      location?: number,
    ): void => {
      dispatch(setCancelNonPickedTask({ poNumber, location }));
    },
  },
};

export const OpenBulkDialogConfig: Record<string, IOpenBulkDialogData | null> =
  {
    [OrderListRowAction.PRIORITIZE_TASK]: {
      title: 'Prioritize Task',
      content: (poNumbers: string[]): string => {
        return `Are you sure to prioritize following POs: \n\n ${poNumbers.join(
          '\n',
        )}?`;
      },
      onConfirm: (
        dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
        poNumbers: string[],
        location?: number,
      ): void => {
        dispatch(bulkPrioritizeOrderPick({ poNumbers, location }));
      },
    },
    [OrderListRowAction.UNPRIORITIZE_TASK]: {
      title: 'Unprioritize Task',
      content: (poNumbers: string[]): string => {
        return `Are you sure to unprioritize following POs: \n\n ${poNumbers.join(
          '\n',
        )}?`;
      },
      onConfirm: (
        dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
        poNumbers: string[],
        location?: number,
      ): void => {
        dispatch(bulkUnPrioritizeOrderPick({ poNumbers, location }));
      },
    },
    [OrderListRowAction.RETRY]: {
      title: 'Submit Retry Update Failed Task',
      content: (poNumbers: string[]): string => {
        return `Are you sure to submit update retry for following POs: \n\n ${poNumbers.join(
          '\n',
        )}?`;
      },
      onConfirm: (
        dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
        poNumbers: string[],
        location?: number,
      ): void => {
        dispatch(bulkRetryUpdateFailedOrder({ poNumbers, location }));
      },
    },
  };
